import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Button, Alert, Typography, Box } from "@curves/ui-base";
import useTemporaryApi from "@apis/useTemporaryApi";
import { isFunction } from "@util/utils";

const TemporariesDeleteDialog = React.forwardRef((props, ref) => {
	const { onClose: onCloseProps, open, sourceData = { list: [], info: [] }, refresh } = props;
	if (!open) return null;
	const { deleteTemporaryApi } = useTemporaryApi();
	const handleCloseOnClick = () => {
		onCloseProps();
	};

	const handleSendOnClick = () => {
		const params = {
			temporaryIDs: sourceData.list,
		};
		doDeleteTemporaryApi(params);
	};

	const doDeleteTemporaryApi = async params => {
		const resp = await deleteTemporaryApi(params);
		if (resp) {
			isFunction(refresh) && refresh();
			onCloseProps();
		} else {
			console.error(resp);
		}
	};

	return (
		<Dialog open={open}>
			<GradientColorHeader onClose={handleCloseOnClick}>刪除</GradientColorHeader>
			<DialogContent>
				<Grid container>
					<Grid item xs={12}>
						<Alert severity="remove" variant="filled" color="error">
							確定要刪除({sourceData.list.length})?
						</Alert>
					</Grid>
					<Grid item xs={12} className="my-2">
						<Grid container>
							<Grid item xs={6}>
								<Typography variant="span" className="text-gray-500">
									標題
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography variant="span" className="text-gray-500">
									筆數
								</Typography>
							</Grid>
						</Grid>
						{sourceData.info.map((target, _index) => {
							const { name, count } = target;
							if (!name) return null;
							return (
								<Grid container spacing={1} key={`error_content_${_index}`}>
									<Grid item xs={1}></Grid>
									<Grid item xs={5}>
										<Typography className="ml-5" variant="h5" compoment="span">
											{name}
										</Typography>
									</Grid>
									<Grid item xs={1}></Grid>
									<Grid item xs={5}>
										<Typography className="ml-3" variant="h5" compoment="span">
											{count}
										</Typography>
									</Grid>
								</Grid>
							);
						})}
					</Grid>
					<Grid item xs={12}>
						<Box className="flex flex-y-flex-center mt-2">
							<Button size="large" variant="contained" color="warning" onClick={handleSendOnClick}>
								確定
							</Button>
						</Box>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
});

export default TemporariesDeleteDialog;
